module.exports = __webpack_public_path__ + "media/images/logo/Oneticket_tour__black_small-2da9976439fbca450f17073b7019c1c8.svg";